import React, { useEffect, useMemo, useState } from "react";
import { Tabs } from "antd";
import { FlattenedField } from "../../../CustomersV2/indexV2";
import { FieldsUpdate, getListCustomerRepair, getListFieldsByCustomer, ICustomer, ICustomerRepair, ListField, updateFieldUser } from "../../../../api/Customer_V2/customerApi_V2";
import { ColumnKey } from "../../../Customers/Tabs/CarListCardClone";
import { VehicleVersionTable } from "../VehicleVersionTable";
import { AppRowCar, buildViewRowsCar, kCity, kRole, makeColumnsCar } from "../VehicleVersionTable/fn";
import { SettingOutlined } from "@ant-design/icons";
import CarFeilds from "./CarFeilds";
import VehicleInformationyTabs from "../VehicleInformationyTabs";
import { IPagination } from "../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup";
import ServiceRecordFeilds from "../ServiceRecords/Components/ServiceRecordFeilds";
import { PaginationProps } from "antd/lib";
import useLoading from "../../../../hook/useLoading";
import useToast from "../../../../hook/useToast";
import useDebounce from "../../../../hook/useDebounce";
import { FIELDTYPE } from "../../../../services/data";
import { flattenFields, getUserPermissions } from "../../../../until";
import useThrottle from "../../../../hook/useThrottle";
import { useSelector } from "react-redux";
import { selectorInfoUser } from "../../../../store/slices/infoUserSlice";
import ModalUpdateVehicleInformation from "./ModalCar/ModalUpdateVehicleInformation";
import MaintenanceHistory from "../ServiceRecords/MaintenanceHistory";
import { selectorCategoryCarIds } from "../../../../store/slices/categoryCarSlice";
import { selectorPermission } from "../../../../store/slices/permissionSlice";


interface IDataFilterActive {
  infoCar: FlattenedField[];
  maintenanceHistory: FlattenedField[];
}

interface IDataFilterNoActive {
  infoCar: ListField[];
  maintenanceHistory: ListField[];

}

const EMPTY_GROUP = {
  infoCar: [],
  maintenanceHistory: [],
};

type PaginationKey = "infoCar" | "maintenanceHistory";

interface Props {
  // isModalUpdateVehicleInformation: boolean
  loadingTable?: boolean
  dataFilterActive: FlattenedField[]

  idCustomer?: number
  listVehicle: ICustomer[]
  // setIsModalUpdateVehicleInformation: (e: boolean) => void

}
const UsedCar: React.FC<Props> = ({
  // isModalUpdateVehicleInformation,
  loadingTable,
  dataFilterActive,
  idCustomer, listVehicle,
  // setIsModalUpdateVehicleInformation
}) => {

  const pushLoading = useLoading()
  const pushToast = useToast();
  const { id, unitTemp } = useSelector(selectorInfoUser)
  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)


  const permissionSlice = useSelector(selectorPermission)
  const { access, edit } = getUserPermissions(permissionSlice, location.pathname)

  useEffect(() => {
    gListFieldsActive()
  }, [])
  const [isSettingShow, setSettingShow] = useState(false)

  const [loadingTableDetail, setLoadingTableDetail] = useState(false)

  const [activeServiceRecordsTab, setActiveServiceRecordsTab] = useState<PaginationKey>("maintenanceHistory");
  const [dataFieldsServiceRecordsActive, setDataFieldsServiceRecordsActive] = useState<IDataFilterActive>(EMPTY_GROUP);
  const [dataFieldsServiceRecordsNoActive, setDataFieldsServiceRecordsNoActive] = useState<IDataFilterNoActive>(EMPTY_GROUP);
  const [columnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([]);

  const [selectedVehicleId, setSelectedVehicleId] = useState<number>();
  const [maintenanceHistory, setMaintenanceHistory] = useState<ICustomerRepair>();

  const [paginationMap, setPaginationMap] = useState<Record<PaginationKey, IPagination>>({
    infoCar: { current: 1, pageSize: 10, total: 0 },
    maintenanceHistory: { current: 1, pageSize: 10, total: 0 },
  });
  const [loadedTabs, setLoadedTabs] = useState({
    infoCar: false,
    maintenanceHistory: false,
  });

  const [infoCar, setInfoCar] = useState<ICustomer[]>([]);


  // #region Modal
  const handleOpenModal = (type: string, id: number) => {
    switch (type) {
      case 'update':
        // setIsModalUpdateVehicleInformation(true)
        break;

      default:
        break;
    }
  }

  //#endregion

  //#region Cấu hình VehicleVersionTable
  const filterColumn = ['nameCar', 'year', 'price'];

  // expanded set
  const [expanded, setExpanded] = React.useState<Set<string>>(new Set());

  // Build rows từ dataCarTest
  const viewRowsCar = useMemo(() =>
    buildViewRowsCar(listVehicle, expanded),
    [expanded, listVehicle]);

  // Toggle expand
  const toggleCarType = React.useCallback((carType: string) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      const key = kCity(carType);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  }, []);

  const toggleBrand = React.useCallback((carType: string, brand: string) => {
    setExpanded((prev) => {
      const next = new Set(prev);
      const key = kRole(carType, brand);
      next.has(key) ? next.delete(key) : next.add(key);
      return next;
    });
  }, []);

  // Columns (tĩnh + động)
  const columnsCar = useMemo(
    () => makeColumnsCar(
      expanded, access, false, toggleCarType, toggleBrand,
      dataFilterActive, handleOpenModal, idCustomer, ["customer_name"],
      permittedCategoryCarIds

    ),
    [expanded, toggleCarType, toggleBrand, columnsMapShow, idCustomer]
  );


  // Đồng bộ columnsMapShow từ cấu hình active
  useEffect(() => {
    const codes = dataFilterActive.map((f) => f.fieldCode) as ColumnKey[];
    setColumnsMapShow(codes);
  }, [dataFilterActive]);
  //#endregion

  const gListFieldsActive = async () => {
    const [activeRes, inactiveRes] =
      await Promise.all([
        getListFieldsByCustomer(FIELDTYPE.maintenanceHistoryForUsed, 1),
        getListFieldsByCustomer(FIELDTYPE.maintenanceHistoryForUsed, 0),
      ]);

    const activeGroups = activeRes?.data ?? [];
    const flattenedFieldsVehicleInvoice = flattenFields(activeGroups);

    setDataFieldsServiceRecordsActive({
      ...dataFieldsServiceRecordsActive,
      maintenanceHistory: flattenedFieldsVehicleInvoice,
    });

    // Ensure all groups from active exist in inactive (even if empty)
    // so unchecking a field always finds its parent group
    const inactiveGroups = inactiveRes?.data ?? [];
    const mergedInactive = [...inactiveGroups];
    for (const ag of activeGroups) {
      if (!mergedInactive.some(ig => ig.id === ag.id)) {
        mergedInactive.push({ id: ag.id, title: ag.title, fields: [] });
      }
    }

    setDataFieldsServiceRecordsNoActive({
      ...dataFieldsServiceRecordsNoActive,
      maintenanceHistory: mergedInactive,
    });
  };

  const gListInfoCar = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {

    if (!idCustomer || !selectedVehicleId) {
      setInfoCar([])
      return;
    }
    pushLoading(true)
    const result = listVehicle.filter((item) => item.vehicleId === selectedVehicleId)
    if (result) {
      setInfoCar(result)
      setPaginationMap(prev => ({
        ...prev,
        infoCar: {
          current: pageCurent,
          pageSize,
          total: result.length,
        },
      }));
    } else {
      pushToast("Không tồn tại xe", "warning")
    }
    // 🔥 QUAN TRỌNG
    setLoadedTabs(prev => ({
      ...prev,
      infoCar: true,
    }));
    pushLoading(false)
  }, 1000)

  const gListCustomerRepair = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {

    if (!idCustomer || !selectedVehicleId) {
      setMaintenanceHistory(undefined)
      return;
    }
    setLoadingTableDetail(true)

    // Xe sử dụng truyền type = 14 để phân biệt với se sở hữ bằng 7
    const result = await getListCustomerRepair(
      idCustomer, selectedVehicleId, unitTemp, permittedCategoryCarIds,
      pageSize, pageCurent, 14
    )
    if (result?.status) {
      setMaintenanceHistory(result.data)
      setPaginationMap(prev => ({
        ...prev,
        maintenance: {
          current: pageCurent,
          pageSize,
          total: result.total,
        },
      }));
    } else {
      pushToast(result?.message, "warning")
    }
    // 🔥 QUAN TRỌNG
    setLoadedTabs(prev => ({
      ...prev,
      maintenanceHistory: true,
    }));
    setLoadingTableDetail(false)
  }, 1000)


  const onRowClickVehicleVersionTable = (row: AppRowCar, rowIndex: number) => {

    if (!row) {
      setSelectedVehicleId(undefined);
      return;
    }

    setSelectedVehicleId(row.idCover ? Number(row.idCover) : 0);

  }


  const onSaveVisibleFields = useThrottle(async (dataFilterActive: FlattenedField[], dataFilterNoActive: ListField[]) => {
    let result: any;
    const activeFields: FieldsUpdate[] = dataFilterActive.map(item => ({
      fieldId: item.id,
      isActive: 1, // hoặc true tùy bạn muốn mặc định là gì
    }));
    const allFieldsDefaultInactive: FieldsUpdate[] = dataFilterNoActive.flatMap(group =>
      group.fields.map(field => ({
        fieldId: field.id,
        isActive: 0,
      }))
    );
    const listActiveFields = activeFields.concat(allFieldsDefaultInactive)

    switch (activeServiceRecordsTab) {

      case 'infoCar': {
        result = await updateFieldUser(id, FIELDTYPE.infoCar, undefined, listActiveFields)
        break;
      }

      case 'maintenanceHistory': {
        result = await updateFieldUser(id, FIELDTYPE.maintenanceHistory, undefined, listActiveFields)
        break;
      }

      default:
        break;
    }

    if (result?.status) {
      pushToast(result?.message, "success")
      setSettingShow(false)

      if (dataFilterActive && dataFilterNoActive) {
        setDataFieldsServiceRecordsActive(prev => ({
          ...prev,
          [activeServiceRecordsTab]: dataFilterActive ?? [],
        }));

        setDataFieldsServiceRecordsNoActive(prev => ({
          ...prev,
          [activeServiceRecordsTab]: dataFilterNoActive ?? [],
        }));
      }

    } else {
      pushToast(result?.message, "warning")
    }
  }, 2000)

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    switch (activeServiceRecordsTab) {
      case "infoCar": {
        gListInfoCar(pageNumber, pageSize)
        break;
      }
      case "maintenanceHistory": {
        gListCustomerRepair(pageNumber, pageSize)
        break;
      }
      default:
        break;
    }
  }

  useEffect(() => {
    if (!selectedVehicleId) return;
    // 1️⃣ RESET
    setInfoCar([]);
    setMaintenanceHistory(undefined);

    setLoadedTabs({
      infoCar: false,
      maintenanceHistory: false
    });

    setPaginationMap({
      ...paginationMap,
      infoCar: { current: 1, pageSize: 10, total: 0 },
    })


    // 2️⃣ GỌI API ĐÚNG TAB
    switch (activeServiceRecordsTab) {
      case "infoCar":
        gListInfoCar();
        break;
      case "maintenanceHistory":
        gListCustomerRepair();
        break;
      default:
        break;
    }
  }, [selectedVehicleId]);

  useEffect(() => {
    if (!selectedVehicleId) return;

    switch (activeServiceRecordsTab) {
      case "infoCar":
        if (!loadedTabs.infoCar) gListInfoCar();
        break;
      case "maintenanceHistory":
        if (!loadedTabs.maintenanceHistory) gListCustomerRepair();
        break;
      default:
        break;
    }
  }, [activeServiceRecordsTab]);

  useEffect(() => {
    if (idCustomer) {
      setSelectedVehicleId(undefined)
      setMaintenanceHistory(undefined)
      setInfoCar([])
    }
  }, [idCustomer])

  return (
    <>
      {
        isSettingShow ?
          <ServiceRecordFeilds
            isSettingShow={isSettingShow}
            recordId={1}
            type={0}
            dataFilterActive={dataFieldsServiceRecordsActive[activeServiceRecordsTab]}
            dataFilterNoActive={dataFieldsServiceRecordsNoActive[activeServiceRecordsTab]}

            onSaveVisibleFields={onSaveVisibleFields}
            onClose={() => setSettingShow(false)}
          /> :
          null
      }


      <div
        className="custom-page-css border rounded "
        style={{ width: "100%" }}
      >
        <VehicleVersionTable<any>
          loadingTable={loadingTable}
          nonDraggableColumnIds={["action"]}
          nonResizableColumnIds={["action"]}
          columns={columnsCar}
          filterColumn={filterColumn}
          rows={viewRowsCar}
          rowClassName={(row) =>
            (row.data.kind === "group-city" || row.data.kind === "group-role") ? "row-group" : ""
          }
          onRowClick={onRowClickVehicleVersionTable}
        />
      </div>
      <div
        className="ag-theme-alpine custom-table-ag custom-page-css custom-tabs relative"
        style={{ width: "100%", marginTop: "16px" }}
      // hidden={!selectedVehicleId}
      >
        <Tabs
          activeKey={activeServiceRecordsTab}
          items={[
            // {
            //   key: "infoCar",
            //   label: (
            //     <span className="custom-page-css font-light text-lg">Thông tin xe</span>
            //   ),
            //   children: (
            //     <VehicleInformationyTabs
            //       dataFieldsActive={dataFieldsServiceRecordsActive.infoCar}
            //       pagination={paginationMap.infoCar}
            //       data={infoCar}

            //       onPaginationChange={onPaginationChange}
            //     />
            //   ),
            // },
            {
              key: "maintenanceHistory",
              label: (
                <span className="custom-page-css font-light text-lg">
                  Lịch sử bảo trì bảo dưỡng
                </span>
              ),
              children: (
                <MaintenanceHistory
                  loadingTableDetail={loadingTableDetail}
                  dataFieldsActive={dataFieldsServiceRecordsActive.maintenanceHistory}
                  pagination={paginationMap.maintenanceHistory}
                  data={maintenanceHistory}
                  idCustomer={idCustomer}
                  onPaginationChange={onPaginationChange}
                />
              ),
            },
          ]}
          onChange={(k) => setActiveServiceRecordsTab(k as PaginationKey)}
        />
        <div className="custom-page-css absolute top-4 right-2">
          <div className='settingCol'>
            <div className='ctr-col-setting'
              onClick={() => setSettingShow(true)}
            >
              <SettingOutlined />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default UsedCar;
